// @flow

export default class FAQ {

    question: string;
    answer: string;
    id: ?string;
    image: ?string;
    sortOrder: ?number;
    isDirty: ?boolean;

    constructor(args: ?Object = {}) {
        this.id = args.id || null;
        this.question = args.question || "";
        this.answer = args.answer || "";
        this.image = args.image || "";
        this.sortOrder = args.sortOrder || 0;
        this.isDirty = Boolean(args.isDirty);
    }

    static create(args: ?Object = {}, id?: string) {
        const _args = { ...args };
        if (Boolean(id)) {
            _args.id = id;
        }
        return JSON.parse(JSON.stringify(new FAQ(_args)));
    }
}
